<template>
    <div class="custom-nav">
        <div class="left">
            <a href="https://www.blacktieskis.com/"><img src="/cart-booking/images/logo.svg"  style="height: 100px; margin-top:-10px" alt="" class="web_img"></a>
            <a href="https://www.blacktieskis.com/"> <img src="/cart-booking/images/logo-white-border.png" style="height: 65px" alt="" class="mobail_img"></a>
        </div>
        <div class="right text-right web-menu">
<!--           <a href="javascript:void(0);" class="btn btn-blue btn-lg m-l-3"-->
<!--              onmouseover="this.style.backgroundColor='#2d82db'; this.style.color='yellow';"-->
<!--              onmouseout="this.style.backgroundColor='#2d82db'; this.style.color='white';">-->
<!--               <select v-model="$i18n.locale" style="background: #2d82db;border: none;width: 100%">-->
<!--                    <option v-for="(lang, i) in langs" :key="`Lang${i}`" :value="lang">-->
<!--                        {{ lang=='fr'?'Detected':'English' }}-->
<!--                    </option>-->
<!--                </select>-->
<!--           </a>-->
<!--            <a  class="btn btn-blue btn-lg toggle-menu" data-toggle="collapse" data-target="#locale-div">-->
<!--                {{ $i18n.locale=='fr'?'Detected':'English' }}-->
<!--            </a>-->
            <span>{{ $i18n.locale=='fr'?'Fr':'En' }}</span>
            <a href="javascript:void(0);" class="custom-dropdown" id="dropdownMenu">
                <br>
                <span class="ctranslate_wrapper" style="margin-top: -27px"></span>
            </a>
            <!-- Custom dropdown menu -->
            <ul class="custom-dropdown-menu" id="dropdownItems">
                <li  v-for="(lang, i) in langs" :key="`Lang${i}`" @click="updateLocale(lang)" >
                    <a class="btn btn-borderless menu-locale">
                        {{ lang=='fr'?'French':'English' }}
                    </a>
                </li>
            </ul>


            <a href="tel:866.360.6433" class="btn btn-lg"><strong>866.360.6433</strong></a>
            <a href="Javascript:void(0);" @click="logout" class="btn btn-blue btn-lg toggle-menu"  v-if="this.auth_user">LOGOUT</a>
            <a @click="setAuthModalType('login')" href="#sibebar_container" data-toggle="modal"  class="btn btn-blue btn-lg loginModal" v-if="!this.auth_user">LOGIN</a>
            <a  class="btn btn-blue btn-lg toggle-menu" data-toggle="collapse" data-target="#demo-menu">
                <i class="fa fa-bars"></i>
            </a>
        </div>
        <div id="demo-menu"  class="collapse">
            <ul class="list-inline">
                <!-- <a href="#covid_19_policy_modal" data-toggle="modal" class="btn btn-borderless btn-lg">COVID 19 POLICY</a> -->
                <a href="/reservations/step1" class="btn btn-borderless btn-lg" v-if="this.auth_user">NEW RESERVATION</a>
                <a href="/frontend/reservations" class="btn btn-borderless btn-lg" v-if="this.auth_user">MY RESERVATIONS</a>
                <a href="/frontend/customers/create" class="btn btn-borderless btn-lg" v-if="this.auth_user">MY PROFILE</a>
                <a href="#contact_us_model" data-toggle="modal" class="btn btn-borderless btn-lg">CONTACT US</a>
            </ul>
        </div>
        <div class="right text-right mobail-menu">
            <a href="javascript:void(0);" class="m-l-3"><i class="btn btn-xs gtranslate_wrapper"></i> </a>
            <a href="tel:866.360.6433"><i class="fa fa-phone"></i></a>
            <a class="times_button"><i class="fa fa-bars"></i></a>
            <div id="footwear">
                <a href=""><img src="/cart-booking/images/logo-white-border.png" alt="" class="left_img"></a>
                <a href="Javascript:void(0);" class="close_button"><img src="/cart-booking/images/close.png" alt=""></a>
                <ul class="list-inline">
                    <!-- <a href="#covid_19_policy_modal" data-toggle="modal">COVID 19 POLICY</a> -->
                    <a href="/reservations/step1" v-if="this.auth_user">NEW RESERVATION</a>
                    <a href="/frontend/reservations" v-if="this.auth_user">MY RESERVATIONS</a>
                    <a href="/frontend/customers/create" v-if="this.auth_user">MY PROFILE</a>
                    <a href="#contact_us_model" data-toggle="modal">CONTACT US</a>
                    <a href="Javascript:void(0);" @click="logout"  v-if="this.auth_user">LOGOUT</a>
                    <a @click="setAuthModalType('login')" class="loginModal" href="#sibebar_container" data-toggle="modal"  v-if="!this.auth_user">LOGIN</a>
                </ul>
            </div>
        </div>
        <auth-modal/>
    </div>
</template>

<script>
import {mapActions, mapState} from "vuex";
import AuthModal from "./modals/AuthModal";

export default {
    name: 'PageHeader',
    components: {AuthModal},
    computed:{
        ...mapState(['auth_user', 'live_site'])
    },
    mounted() {
        $(document).ready(function($) {
            $(".times_button").click(function(){
                $("#footwear").show();
            })
            $(".close_button").click(function(){
                $("#footwear").hide();
            })

            $(document).on('click', function (e){
                /* for web close navbar*/
                var menu_opened = $('#demo-menu').hasClass('in');

                if(!$(e.target).closest('#demo-menu').length &&
                    !$(e.target).is('#demo-menu') &&
                    menu_opened === true){
                    $('#demo-menu').collapse('toggle');
                }

                // for mobile hide mobile menue on anywhere click
                if( $(e.target).closest(".times_button").length > 0 ) {
                    return false;
                }else{
                    $("#footwear").hide();
                }
            });

        });


        document.getElementById('dropdownMenu').addEventListener('click', function(event) {
            event.stopPropagation();  // Prevent the window click from immediately closing the dropdown
            var menu = document.getElementById('dropdownItems');
            menu.classList.toggle('show'); // Toggle the display of the menu
        });

        // Close dropdown if clicked outside
        window.addEventListener('click', function() {
            var menu = document.getElementById('dropdownItems');
            if (menu.classList.contains('show')) {
                menu.classList.remove('show');
            }
        });
        if(localStorage.getItem('selectedLocale')=='fr'){
            this.$i18n.locale=localStorage.getItem('selectedLocale');
        }
    },
    methods: {
        ...mapActions(['logout', 'setAuthModalType']),
        updateLocale(lang){
            this.$i18n.locale = lang;
            localStorage.setItem('selectedLocale', this.$i18n.locale)

            const localeDiv = this.$el.querySelector('#locale-div');
            if (localeDiv) {
                localeDiv.classList.remove('in');
            }
        }
    },
    data () {
        return { langs: ['fr', 'en'] }
    }
}
</script>
<style>
.ctranslate_wrapper{
    background-image: url("../../public/images/locale_logo.svg");
    opacity: 0.8;
    border-radius: 50%;
    height: 40px;
    width: 40px;
    cursor: pointer;
    display: block;
    transition: all 0.3s;
}
/* Style the custom dropdown */
.custom-dropdown {
    margin-top:10px;
    position: relative;
    display: inline-block;
    cursor: pointer;
}

.custom-dropdown-menu {
    display: none;
    position: absolute;
    background-color: #f9f9f9;
    min-width: 160px;
    box-shadow: 0px 8px 16px rgba(0,0,0,0.2);
    z-index: 1;
    list-style: none;
    padding: 0;
    margin: 0;
}

/* Style for the dropdown items */
.custom-dropdown-menu li {
    padding: 10px;
}

.custom-dropdown-menu li a {
    color: black;
    text-decoration: none;
    display: block;
}

.custom-dropdown-menu li:hover {
    background-color: #f1f1f1;
}

/* Show the dropdown menu when clicked */
.show {
    display: block;
}
#sibebar_container.modal{
    padding-right: 10px !important;
}
.m-l-3{
    margin-left: 3px!important;
}
</style>
